<script lang="ts">var _a;
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import { JanusSignonManagerToken, JanusSignonManager } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { f7 } from 'framework7-svelte';
import { resolveUrl } from '../../../../../js/url';
export let element;
export let sources;
const tabContext = getContext(CardsTabContextKey);
const signonManager = getToken(ROOT, JanusSignonManagerToken);
// const signonStatus = signonManager.getStatusComponent().store;
$: profileStore = findSourceStore($sources, 'YinzCamSignonProfileSegment');
$: sourceStore = findSourceStore($sources, 'YinzCamDropsServerCurrentDrop');
// $: addressCity = $profileStore?.AddressCity || '';
// $: addressCountry = $profileStore?.AddressCountry || '';
// $: addressDivision1 = $profileStore?.AddressDivision1 || '';
// $: addressPostal = $profileStore?.AddressPostal || '';
$: emailAddress = ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.Email) || "";
// $: addressStreet =
//   ($profileStore?.AddressStreet1 || '') +
//   ' ' +
//   ($profileStore?.AddressStreet2 || '');
// $: valueAddressCity = addressCity;
// $: valueAddressCountry = addressCountry;
// $: valueAddressDivision1 = addressDivision1;
// $: valueAddressPostal = addressPostal;
// $: valueAddressStreet = addressStreet.trim();
$: valueEmailAddress = emailAddress;
$: redirectPage = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.redirectPage) || ($sourceStore === null || $sourceStore === void 0 ? void 0 : $sourceStore.WinPage) || "DropLobby";
let errorCode = "";
function onSubmit() {
    // const data = {
    //   YinzId: $profileStore?.YinzId || "",
    //   NickName: $profileStore?.NickName || "",
    //   ImageUrl: $profileStore?.ImageUrl || "",
    //   FirstName: $profileStore?.FirstName || "",
    //   LastName: $profileStore?.LastName || "",
    //   Email: valueEmailAddress.trim(),
    //   AddressCity: valueAddressCity.trim(),
    //   AddressCountry: valueAddressCountry.trim(),
    //   AddressDivision1: valueAddressDivision1.trim(),
    //   AddressPostal: valueAddressPostal.trim(),
    //   AddressStreet1: valueAddressStreet.trim(),
    //   AddressStreet2: "",
    //   ExtraData: $profileStore?.ExtraData || "",
    // };
    const data = {
        YinzId: ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.YinzId) || "",
        NickName: ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.NickName) || "",
        ImageUrl: ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.ImageUrl) || "",
        FirstName: ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.FirstName) || "",
        LastName: ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.LastName) || "",
        Email: valueEmailAddress.trim(),
        ExtraData: ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.ExtraData) || "",
    };
    if (!data.Email) {
        errorCode = "Please input all fields";
        return;
    }
    errorCode = "";
    signonManager.updateUser(data);
    alert("Your email has been submitted.");
    setTimeout(() => {
        resolveUrl(redirectPage).func();
    }, 300);
}
</script>

<div class="profile-page">
  <section class="logo">
    <img src="/static/logos/nhl_chi-logo.png" alt="ChI NBA LOGO" />
  </section>
  <section class="header-title">WHAT IS YOUR EMAIL?</section>
  <section class="desc">We will contact you about your prize shortly</section>
  <form action="#" on:submit|preventDefault|stopPropagation={onSubmit}>
    <section class="input-group">
      <!-- <div class="street-part">
        <div class="map-marker">
          <img src="/static/icons/map-marker.png" alt="map-marker" />
        </div>
        <input
          class="street-input"
          placeholder="Street"
          bind:value={valueAddressStreet}
        />
      </div> -->
      
      <div class="street-part">
        <input
          class="street-input"
          placeholder="Email"
          bind:value={valueEmailAddress}
        />
      </div>

      <!-- <div class="detail-info">
        <input
          type="text"
          placeholder="City"
          class="input-item"
          bind:value={valueAddressCity}
        />
        <input
          type="text"
          placeholder="State"
          class="input-item"
          bind:value={valueAddressDivision1}
        />
      </div>
      <div class="detail-info">
        <input
          type="text"
          placeholder="Country"
          class="input-item"
          bind:value={valueAddressCountry}
        />
        <input
          type="text"
          placeholder="Postal Code"
          class="input-item"
          bind:value={valueAddressPostal}
        />
      </div> -->
    </section>
    <section class="button-box">
      <button class="btn-save button">SAVE</button>
    </section>
    <div class="error">{errorCode}</div>
  </form>
</div>

<style lang="scss">*,
*::after,
*::before {
  box-sizing: border-box;
}

.input-group {
  width: 100%;
  padding: 0 30px 0 28px;
}

.input-item {
  height: 40px;
  border-radius: 30px;
  background-color: #fff;
  min-width: 0;
  padding: 11px 7.9px 11px 20px;
  margin: 0 15px 0 0;
  flex: 1;
  font-family: 'SF UI Display';
  font-size: 15px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000;
}

.input-item:focus {
  outline: 0;
}

.input-item:last-child {
  margin-right: 0px;
}

.street-part {
  height: 40px;
  border-radius: 30px;
  margin: 16px 0 12px 0;
  padding: 9px 11px 9px 20px;
  background-color: #fff;
  display: flex;
  width: 100%;
}

.street-part .map-marker {
  width: 30px;
  height: 22px;
}

.street-part .map-marker img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.street-part input {
  font-family: 'SF UI Display';
  font-size: 15px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000;
  margin: 0;
  border: none;
  width: calc(100% - 30px);
}

.street-part input:focus {
  outline: 0;
}

.button-box {
  margin: 59px 0 0 0;
  display: flex;
  justify-content: center;
}

.button-box .btn-save {
  width: 180px;
  height: 42px;
  padding: unset;
  box-shadow: 0 5px 6px 0 rgba(0, 0, 0, 0.22);
  background-color: #fff;
  font-family: 'SF UI Display';
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.78px;
  text-align: center;
  color: #161616;
  border: none;
}

.profile-page {
  background-color: #000;
  padding: 88px 0;
  text-align: center;
  width: 100%;
}

.profile-page span {
  font-weight: bold;
}

.logo img {
  width: 90px;
  height: 81px;
}

.detail-info {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0 0 12px 0;
}

.detail-info:last-child {
  margin-bottom: 0px;
}

.header-title {
  text-align: left;
  margin: 12px 28px;
  font-family: 'SF UI Display';
  font-size: 42px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.07;
  letter-spacing: normal;
  color: #fff;
}

.desc {
  text-align: left;
  margin: 12px 30px 16px 31px;
  font-family: 'SF UI Display';
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: 0.5px;
  color: #fff;
}

.error {
  margin: 20px 0 0 0;
  color: white;
}</style>
